import { translate as t } from '@thoughtspot/i18n';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Checkbox } from '../../../../checkbox';
import styles from './checkbox-cell.module.scss';
export const CheckboxCell = (props) => {
    const { node, api, data, colDef, context } = props;
    const [isSelected, setIsSelected] = useState(node.isSelected());
    const isCheckboxHidden = context.hideRowCheckbox
        ? context.hideRowCheckbox(data)
        : false;
    const shouldCheckboxBeDisabled = () => {
        const selectedNodes = api.getSelectedNodes();
        const cellData = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) && data[colDef.colId] ? data[colDef.colId] : {};
        const isDisabled = !_.isNil(cellData.limitSelectionTo) &&
            selectedNodes.length >= cellData.limitSelectionTo &&
            !node.isSelected();
        return isDisabled;
    };
    // Initialize disabled with shouldCheckboxBeDisabled as there will be cases where rendering
    // we want the state to be set correctly with some boxes checked and limit threshold should also be there
    const [disabled, setDisabled] = useState(shouldCheckboxBeDisabled());
    const checkHandler = (event) => {
        const { checked } = event.target;
        node.setSelected(checked);
    };
    const rowSelectionListener = (e) => {
        setIsSelected(e.node.isSelected());
    };
    const selectionChangedListener = () => {
        setDisabled(shouldCheckboxBeDisabled());
    };
    useEffect(() => {
        node.addEventListener('rowSelected', rowSelectionListener);
        api.addEventListener('selectionChanged', selectionChangedListener);
        return () => {
            node.removeEventListener('rowSelected', rowSelectionListener);
            api.removeEventListener('selectionChanged', selectionChangedListener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (isCheckboxHidden)
        return null;
    const ariaLabel = isSelected
        ? t('radiantReact.tableListView.checkboxCell.ariaLabelDeselect')
        : t('radiantReact.tableListView.checkboxCell.ariaLabelSelect');
    return (React.createElement("div", { className: styles.checkboxCellContainer },
        React.createElement(Checkbox, { onChange: checkHandler, checked: !!isSelected, label: "", id: node.id, hideLabel: true, disabled: disabled, ariaLabel: ariaLabel })));
};
//# sourceMappingURL=checkbox-cell.js.map